import { EVENTDETAILS } from "../actions/eventDetailsAction";

const default_event_details = {
    eventId: 0,
    eventType: '',
    creatorAvatar: '',
    creatorId: 0,
    title: '',
    creator: '',
    description: '',
    startDay: '',
    startTime: '',
    location: '',
    privacity: '',
    image: '',
    caracteristics: '',
    guestsId: '',
    slug: '',
}


const eventDetailsReducer = (state = default_event_details, action) => {

    switch (action.type) {
        case EVENTDETAILS: {
            return {

                eventId: action.data.eventID,
                eventType: action.data.eventType,
                creatorAvatar: action.data.creatorAvatar,
                creatorId: action.data.creatorId,
                title: action.data.eventTitle,
                creator: action.data.creatorName,
                description: action.data.eventDescription,
                startDay: action.data.startDay,
                startTime: action.data.startHour,
                guestsId: action.data.guestsId,

                location: action.data.eventLocation,
                locationCoords: action.data.eventLocationCoords,
                privacity: action.data.eventPrivacity,
                image: action.data.eventImage,
                caracteristics: action.data.eventCharacteristics,
                slug: action.data.slug,
            }
        }

        default: return state;
    }
}

export default eventDetailsReducer